import React from 'react';

import { ResponsivePicture } from '@/components/ResponsivePicture';
import img2MobImg from '@public/img/adviser/resources/marketing-toolkit/img-2-mob.webp';
import img2TabImg from '@public/img/adviser/resources/marketing-toolkit/img-2-tab.webp';
import img2Img from '@public/img/adviser/resources/marketing-toolkit/img-2.webp';
export const NewFeatures = () => {
  return (
    <div className="container mx-auto">
      <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center bg-[#F3F4F8] rounded-xl overflow-hidden">
        {/* Text Content */}
        <div className="pt-8 pb-8 pl-6 pr-6 md:pb-12 md:pl-12 md:pr-12">
          <p className="text-[#006EB7] font-semibold text-base md:text-xl mb-3">New features</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-[#0C0D1A] pb-6 md:w-[30rem]">
            Guide to Lifetime Mortgages
          </h2>

          <p className="text-[#373945] text-base pb-6 font-450 md:w-[30rem]">
            Use our new guide to support your clients in understanding how they can benefit from a lifetime mortgage.
          </p>

          <a
            href="https://puremediastorage.blob.core.windows.net/pure-web-media/toolkit/guide-to-lifetime-mortgages-brochure.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="plain-text-link font-semibold cursor-pointer inline-flex items-center"
          >
            View guide
            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <path d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5" stroke="#006EB7" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>

        <div className="w-full">
          <ResponsivePicture
            mobile={img2MobImg}
            tablet={img2TabImg}
            desktop={img2Img}
            alt="Guide to Lifetime Mortgages preview on tablet"
            sizes="(min-width: 1024px) 50vw, 100vw"
            className="block w-full h-auto"
            pictureClassName="block w-full"
          />
        </div>
      </div>
    </div>
  );
};
